
















































import { defineComponent } from 'vue';
import { PropType } from 'vue'
import { Boleto } from '../../../../store/boletos';



export default defineComponent({
    props: {
        boleto: {
            type: Object as PropType<Boleto>,
            required: true
        }
    }

})
